import {
  observable,
  action
} from 'mobx'
import {store} from '../store.index';
import { cookies } from 'Api/index';
import { getAdList } from 'Api/fwApi/webpdfapi';
// import jsonp from 'jsonp';

class fwAdver {
  @observable advertInfo = null;
  @observable advertDialog = false;
  @observable getAdListBegin = false;
  @observable hasData = false
  @observable onceShow = false
  
  @action setOnceShowAdvert = (val) => {
    this.onceShow = val
  }
  @action setAdvertList = (val) => {
    this.advertInfo = val
  }
  @action advertDialogHide = () => {
    this.advertDialog = false
    // 处理缓存
    switch(this.advertInfo.showType) {
      case 2:
        this.setAdvertCookie(new Date(`9999-12-31 23:59:59`))
        break
      case 3:
        let nowDay = new Date();
        let year = nowDay.getFullYear();
        let month = nowDay.getMonth()+1;
        let day = nowDay.getDate() + 1;
        this.setAdvertCookie(new Date(`${year}-${month}-${day} 00:00:00`))
        break
    }
  }
  @action advertDialogShow = () => {
    if(this.onceShow) {
      return
    }
    let advert = this.advertInfo
    // advert.validObject = 3
    let { userId, identity } = store.userNewStore.userData || {userId: 'NoUser', identity: ''}
    console.log(store.userNewStore.userData)
    if ((advert.validObject == 3 && identity == 'vip') || (advert.validObject == 2 && identity != 'vip')) {
      console.log('advertDialogShow return')
      // 身份不满足，不进行弹窗
      return
    }
    let cookie = cookies.get(`advert${userId}${advert.id}`)
    if(!cookie) {
      this.advertDialog = true
      this.setOnceShowAdvert(true)
    }
  }

  @action getAdvert = () => {
    if (this.advertInfo) { // 有数据，判断是否已经展示
      this.advertDialogShow()
      return 
    }
    if(this.getAdListBegin) {
      return
    }
    if(this.hasData) {
      return
    }
    this.getAdListBegin = true

    // let url = `http://file.foxitreader.cn/foxit-edit-online-admin/advertise/ad.json`
    // let options = {param: "jsonpcallback"}
    // jsonp(url, options, (err, data) => {
    //   if(!err) {
    //     console.log(data)
    //     // resolve(data)
    //   } else {
    //     console.log(err)
    //   }
    // })

    // setTimeout(() => {
    //   const $ = window.UIExtension.jQuery;
    //   console.log(window.UIExtension)
    //   $.ajax({
    //     type: "GET",
    //     url: url,
    //     dataType: "jsonp",
    //     jsonp: 'callback',
    //     success: function (response) {
    //       console.log(response)
    //     }
    //   })
    // }, 1000)
    
    // $.getJSON('http://file.foxitreader.cn/foxit-edit-online-admin/advertise/ad.json?soncallback=?', (data) => {
    //   console.log(data)
    // })
    getAdList().then(res => {
      if (res.ret == 0 && res.data) {
        this.hasData = true
        this.advertInfo = res.data.length > 0 ? res.data[0] : null
        if(this.advertInfo && res.data.length > 0) {
          this.advertDialogShow()
        }
      }
      this.getAdListBegin = false
    }).catch(err => {
      this.getAdListBegin = false
      console.log(err)
    })
  }

  @action setAdvertCookie = (expires) => {
    let advert = this.advertInfo
    let { userId } = store.userNewStore.userData || {userId: 'NoUser', identity: ''}
    // let cookie = cookies.get(`advert${userId}${advert.id}`) || null;
    if(expires) {
      cookies.set(`advert${userId}${advert.id}`, true,{ expires: expires })
    } else {
      cookies.set(`advert${userId}${advert.id}`, true)
    }
  }
}

export default fwAdver;